"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJrDefenseStatus = getJrDefenseStatus;
exports.getJrTractorBeamStatus = getJrTractorBeamStatus;
exports.getJrTransporterStatus = getJrTransporterStatus;
exports.getNumberOfRepairsLeft = getNumberOfRepairsLeft;
exports.isJrCommunicationActive = isJrCommunicationActive;
exports.isJrDefenseActive = isJrDefenseActive;
exports.isJrPowerActive = isJrPowerActive;
exports.isJrRepairsActive = isJrRepairsActive;
exports.isJrScannerActive = isJrScannerActive;
exports.isJrThrustersActive = isJrThrustersActive;
exports.isJrTractorBeamActive = isJrTractorBeamActive;
exports.isJrTransporterActive = isJrTransporterActive;
var _missionStateConstants = require("../constants/missionStateConstants");
var _general = require("./general");
/**
 * Whether or not the repairs station is active on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {boolean}
 */
function isJrRepairsActive(juniorMissionState) {
  return juniorMissionState?.stationData.repair.active || false;
}

/**
 * Gets the target status of the defense station on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {TargetStatus}
 */
function getJrDefenseStatus(juniorMissionState) {
  return juniorMissionState?.stationData.defense.status || 'OFFLINE';
}

/**
 * Whether or not the defense station is active on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {boolean}
 */
function isJrDefenseActive(state) {
  return getJrDefenseStatus(state) !== 'OFFLINE';
}

/**
 * Whether or not the communication station is active on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {boolean}
 */
function isJrCommunicationActive(juniorMissionState) {
  return !!juniorMissionState && typeof juniorMissionState.stationData.communication.groupRequiredConnectionCount === 'number';
}

/**
 * Gets the online/offline status of the transporter station on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {'OFFLINE'|'ONLINE'}
 */
function getJrTransporterStatus(juniorMissionState) {
  return juniorMissionState?.stationData.transporter.status || 'OFFLINE';
}

/**
 * Whether or not the transporter station is active on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {boolean}
 */
function isJrTransporterActive(juniorMissionState) {
  return getJrTransporterStatus(juniorMissionState) !== 'OFFLINE';
}

/**
 * Whether or not the power station is active on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {boolean}
 */
function isJrPowerActive(juniorMissionState) {
  return juniorMissionState ? juniorMissionState.stationData.power.isActive : false;
}

/**
 * Gets the target status of the tractor beam station on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {TargetStatus}
 */
function getJrTractorBeamStatus(juniorMissionState) {
  return juniorMissionState ? juniorMissionState.stationData.tractorBeam.status : 'OFFLINE';
}

/**
 * Whether or not the tractor beam station is active on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {boolean}
 */
function isJrTractorBeamActive(state) {
  return getJrTractorBeamStatus(state) !== 'OFFLINE';
}

/**
 * Whether or not the scanner station is active on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {boolean}
 */
function isJrScannerActive(juniorMissionState) {
  return juniorMissionState ? juniorMissionState.stationData.scanner.isActive : false;
}

/**
 * Whether or not the thrusters station is active on a junior mission
 * @param {?JuniorMissionFullState} missionState
 * @returns {boolean}
 */
function isJrThrustersActive(juniorMissionState) {
  return juniorMissionState ? juniorMissionState.stationData.thrusters.isActive : false;
}

// Junior Repair Selectors

/**
 * Calculates how many repairs are needed to finish the jrRepairs game based off of
 * ship health and healthPerRepair.
 */
function getNumberOfRepairsLeft(juniorMissionState) {
  if (!juniorMissionState) {
    return 0;
  }
  const shipHealth = (0, _general.getShipHealthFromMission)(juniorMissionState);
  const {
    repair
  } = juniorMissionState.stationData;
  return Math.ceil((_missionStateConstants.MAX_SHIP_HEALTH - shipHealth) / repair.healthPerRepair);
}